import { createSelector } from '@ngrx/store';
import { DocumentTypeCategory } from 'app/profile/models/supplier.model';
import { SelectSupplierModuleState } from '../suppliermodule.selector';

export const SelectMasterDataState = createSelector(SelectSupplierModuleState, state => state.MasterData);

export const SelectSupplierAddressTypes = createSelector(SelectMasterDataState, state => state && state.SupplierContactTypes);

// Get Countries list
export const SelectCountries = createSelector(SelectMasterDataState,
    state => state.countries ? state.countries.sort((x, y) => x.name > y.name ? 1 : -1) : null);

export const SelectLanguages = createSelector(SelectMasterDataState, state => state && state.languages);
export const SelectRegions = createSelector(SelectMasterDataState, state => state && state.regions);
export const SelectContactRoles = createSelector(SelectMasterDataState, state => state && state.roles);
export const getSupplierParts = createSelector(SelectMasterDataState, state => state && state.parts);
export const SelectToolCategories = createSelector(SelectMasterDataState, state => state && state.toolCategories);
export const SelectToolSubCategories = createSelector(SelectMasterDataState, state => state && state.toolSubCategories);
export const SelectEntities = createSelector(SelectMasterDataState, state => state.entities);
export const SelectCurrencies = createSelector(SelectMasterDataState, state => state.currencies);
export const SelectDocumentTypes = createSelector(SelectMasterDataState, state => state.documentTypes);

export const SelectDiversityTypes = createSelector(SelectMasterDataState, state => state.DiversityTypes);
export const SelectAgencyType = createSelector(SelectMasterDataState, state => state.AgencyTypes);

export const SelectDocumentTypesByCategory = (c: DocumentTypeCategory[]) =>
    createSelector(SelectMasterDataState, state =>
        state.documentTypes ? state.documentTypes
            .filter(x => c.indexOf(x.category) > -1)
            .sort((a, b) => a.name > b.name ? 1 : -1) : null);

export const SelectFormTemplate = createSelector(SelectMasterDataState,state => state.FormTemplate);
export const SelectContextVerbiage = createSelector(SelectMasterDataState, state => state && state.contextVerbiage);
export const SelectTax1099Boxes = createSelector(SelectMasterDataState, state => state.Tax1099Boxes);
